import { bowserFlags } from 'lib/bowser'

export const FETCH_MINIMAL_VIEW = 'FETCH_MINIMAL_VIEW'
export const fetchMinimalView = async () => bowserFlags.babylistApp
